import { render, staticRenderFns } from "./pointDetail.vue?vue&type=template&id=0d40612f&scoped=true&"
import script from "./pointDetail.vue?vue&type=script&lang=js&"
export * from "./pointDetail.vue?vue&type=script&lang=js&"
import style0 from "./pointDetail.vue?vue&type=style&index=0&id=0d40612f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40612f",
  null
  
)

export default component.exports